export default __webpack_public_path__ + "static/Logo Placement – TDP – 1280px-3feb7c6f50a34a367dcf42ed315e310e.png";